import {useEffect, useState} from 'react';
import styles from './ReportItemView.module.css';
import {IReportAction, TableRow} from "../../types/types.table.ts";
import {postUser} from "../../helper/http.ts";

interface AppBarProps {
  action: IReportAction;
  row: TableRow;
}

export default function ReportItemView({
    action,
    row
}: AppBarProps) {
    const [page, setPage] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {


      const body: any = {
          module: action.module,
          page: page.toString(),
          per_page: "1",
          sort_direction: "+",
          sort_field: "id",
          filters: {},
      };

      for (let key in action.params) {
          body.filters[key] = row[action.params[key]];
      }

        postUser("crud/list", body).then((res) => {

            setData(res.data);

            setLoading(false);
        });

    }, [page]);

    if (loading) return <div>loading...</div>

    if (data.length === 0) return <div>No items found</div>;

    return (
        <div className={styles.wrapper}>
            <table className={styles.prettyTable}>
            <tbody>
                {(action.fields || Object.keys(data[0])).map((item) => (
                <tr key={item}>
                    <td>{item}</td>
                    <td>{data[0][item]}</td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
    );
}